import { CustomerListOutput } from '@connect-carrier/hooks/useFetchCustomerList';
import { loadTenantTheme } from '@connect-carrier/util/tenantTheme';
import { getLocalStorage, setLocalStorage } from '@utils/localStorage';
import { win } from '@utils/win';

export const getSelectedCustomer = (): Maybe<CustomerListOutput> => {
  return getLocalStorage('selectedCustomer');
};

export const getSelectedTenantCode = (): string => {
  return getLocalStorage('tenantId') || '';
};

const getLoadedTenantId = (): string => {
  return (win as fixMe).__TENANT_ID__ || 'default';
};

export const setSelectedCustomer = (data: Maybe<CustomerListOutput>): void => {
  setLocalStorage('selectedCustomer', data);
  // Persisting selected customer in local storage to maintain selection across sessions and page reloads.
  setLocalStorage('tenantId', data?.tenantCode);

  const loadedTenantId = getLoadedTenantId();
  const newTenantCode = data?.tenantCode;

  if (newTenantCode && loadedTenantId !== newTenantCode) {
    loadTenantTheme(newTenantCode).catch(() => {
      win.location.reload();
    });
  }
};
